import {
  createSimpleTask,
  createTerminateTask,
  getTaskReferenceName,
  wrapVariables
} from 'Automations/nodeDefinitions/conductor'
import { NodeDefinition } from '../../types'
import { EndNodeConfigForm } from './end.configForm'
import { EndEditorNode } from './end.editorNode'
import { EndNodeIcon } from './end.icon'
import { handlesConnected, notForked } from './end.validators'
import { TASK_EXECUTORS } from 'Automations/automations.constants'

export type Config = {
  name: string
}

type TaskName = 'cancel_manual_task' | 'terminate'

const taskReferenceBuilder = getTaskReferenceName<TaskName>('END')

export const endNodeDefinition: NodeDefinition<Config> = {
  name: 'End',
  editorNode: EndEditorNode,
  icon: EndNodeIcon,
  configForm: EndNodeConfigForm,
  defaultConfig: {
    name: ''
  },
  validation: {
    node: { ERROR: [notForked], WARN: [] },
    config: {
      name: { ERROR: [], WARN: [] }
    },
    handles: { ERROR: [handlesConnected], WARN: [] }
  },
  taskTransformer: ({ nodeId }) => {
    const taskReferenceName = taskReferenceBuilder(nodeId)

    return [
      /**
       * Clean up any pending manual tasks before completing the workflow.
       * This is especially useful when there are parallel branches, each with
       * their own manual task. This will make sure these manual tasks aren't
       * hanging around if one branch ends the workflow.
       */
      createSimpleTask({
        name: 'cancel_manual_task',
        taskReferenceName: taskReferenceName('cancel_manual_task'),
        inputParameters: {
          taskExecutorConfiguration: {
            version: 1,
            executor: TASK_EXECUTORS.cancelManualTask
          },
          data: wrapVariables({
            workflowId: 'workflow.workflowId'
          })
        }
      }),
      createTerminateTask({
        name: 'terminate',
        taskReferenceName: taskReferenceName('terminate'),
        inputParameters: { terminationStatus: 'COMPLETED' }
      })
    ]
  }
}
